/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './AiAgentService';
import * as Queries from './AiAgentService.dfc.new';
import type { AdditionalContextArgs } from './AiAgentService.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseIsMaintenanceModeEnabledQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.IsMaintenanceModeEnabledResponseType>
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'isMaintenanceModeEnabled',
            References.IsMaintenanceModeEnabledResponseType
          >
        : References.IsMaintenanceModeEnabledResponseType)
    | undefined;
};

export function useIsMaintenanceModeEnabledQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.IsMaintenanceModeEnabledResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseIsMaintenanceModeEnabledQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.IS_MAINTENANCE_MODE_ENABLED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            isMaintenanceModeEnabled: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseIsMaintenanceModeEnabledQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseIsMaintenanceModeEnabledQueryReturn<T>;
}

type UseIsMaintenanceModeEnabledLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.IsMaintenanceModeEnabledResponseType>,
    {},
    T extends true
      ? Record<
          'isMaintenanceModeEnabled',
          References.IsMaintenanceModeEnabledResponseType
        >
      : References.IsMaintenanceModeEnabledResponseType
  >;

export function useIsMaintenanceModeEnabledLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.IsMaintenanceModeEnabledResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseIsMaintenanceModeEnabledLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.IS_MAINTENANCE_MODE_ENABLED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            isMaintenanceModeEnabled: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseIsMaintenanceModeEnabledLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseIsMaintenanceModeEnabledLazyQueryReturn<T>;
}

type UseIsMaintenanceModeEnabledSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.IsMaintenanceModeEnabledResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'isMaintenanceModeEnabled',
        References.IsMaintenanceModeEnabledResponseType
      >
    : References.IsMaintenanceModeEnabledResponseType;
};

export function useIsMaintenanceModeEnabledSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.IsMaintenanceModeEnabledResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseIsMaintenanceModeEnabledSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.IS_MAINTENANCE_MODE_ENABLED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            isMaintenanceModeEnabled: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseIsMaintenanceModeEnabledSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseIsMaintenanceModeEnabledSuspenseQueryReturn<T>;
}

type UseCreateAgentMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.CreateAgentResponseType>,
  References.CreateAgentRequestType,
  T extends true
    ? Record<'createAgent', References.CreateAgentResponseType>
    : References.CreateAgentResponseType
>;

export function useCreateAgentMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.CreateAgentResponseType>,
    References.CreateAgentRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCreateAgentMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CREATE_AGENT_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            createAgent: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCreateAgentMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCreateAgentMutationReturn<T>;
}

type UseUpdateAgentProfileMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateAgentProfileResponseType>,
    References.UpdateAgentProfileRequestType,
    T extends true
      ? Record<'updateAgentProfile', References.UpdateAgentProfileResponseType>
      : References.UpdateAgentProfileResponseType
  >;

export function useUpdateAgentProfileMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateAgentProfileResponseType>,
    References.UpdateAgentProfileRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateAgentProfileMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_AGENT_PROFILE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateAgentProfile: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateAgentProfileMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateAgentProfileMutationReturn<T>;
}

type UseGetAgentProfileByUserIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAgentProfileByUserIdResponseType>,
    References.GetAgentProfileByUserIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAgentProfileByUserId',
            References.GetAgentProfileByUserIdResponseType
          >
        : References.GetAgentProfileByUserIdResponseType)
    | undefined;
};

export function useGetAgentProfileByUserIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAgentProfileByUserIdResponseType>,
    References.GetAgentProfileByUserIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentProfileByUserIdQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_AGENT_PROFILE_BY_USER_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAgentProfileByUserId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAgentProfileByUserIdQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAgentProfileByUserIdQueryReturn<T>;
}

type UseGetAgentProfileByUserIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAgentProfileByUserIdResponseType>,
    References.GetAgentProfileByUserIdRequestType,
    T extends true
      ? Record<
          'getAgentProfileByUserId',
          References.GetAgentProfileByUserIdResponseType
        >
      : References.GetAgentProfileByUserIdResponseType
  >;

export function useGetAgentProfileByUserIdLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAgentProfileByUserIdResponseType>,
    References.GetAgentProfileByUserIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentProfileByUserIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_AGENT_PROFILE_BY_USER_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAgentProfileByUserId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAgentProfileByUserIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAgentProfileByUserIdLazyQueryReturn<T>;
}

type UseGetAgentProfileByUserIdSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetAgentProfileByUserIdResponseType>,
    References.GetAgentProfileByUserIdRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getAgentProfileByUserId',
        References.GetAgentProfileByUserIdResponseType
      >
    : References.GetAgentProfileByUserIdResponseType;
};

export function useGetAgentProfileByUserIdSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAgentProfileByUserIdResponseType>,
    References.GetAgentProfileByUserIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentProfileByUserIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_AGENT_PROFILE_BY_USER_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAgentProfileByUserId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAgentProfileByUserIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAgentProfileByUserIdSuspenseQueryReturn<T>;
}

type UseGetAgentByUserIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAgentByUserIdResponseType>,
    References.GetAgentByUserIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getAgentByUserId', References.GetAgentByUserIdResponseType>
        : References.GetAgentByUserIdResponseType)
    | undefined;
};

export function useGetAgentByUserIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAgentByUserIdResponseType>,
    References.GetAgentByUserIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentByUserIdQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_AGENT_BY_USER_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAgentByUserId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAgentByUserIdQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetAgentByUserIdQueryReturn<T>;
}

type UseGetAgentByUserIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAgentByUserIdResponseType>,
    References.GetAgentByUserIdRequestType,
    T extends true
      ? Record<'getAgentByUserId', References.GetAgentByUserIdResponseType>
      : References.GetAgentByUserIdResponseType
  >;

export function useGetAgentByUserIdLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAgentByUserIdResponseType>,
    References.GetAgentByUserIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentByUserIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_AGENT_BY_USER_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAgentByUserId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAgentByUserIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAgentByUserIdLazyQueryReturn<T>;
}

type UseGetAgentByUserIdSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetAgentByUserIdResponseType>,
    References.GetAgentByUserIdRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getAgentByUserId', References.GetAgentByUserIdResponseType>
    : References.GetAgentByUserIdResponseType;
};

export function useGetAgentByUserIdSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAgentByUserIdResponseType>,
    References.GetAgentByUserIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentByUserIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_AGENT_BY_USER_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAgentByUserId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAgentByUserIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAgentByUserIdSuspenseQueryReturn<T>;
}

type UseGetAiAgentOrThrowIfMultipleQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAiAgentOrThrowIfMultipleResponseType>
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAiAgentOrThrowIfMultiple',
            References.GetAiAgentOrThrowIfMultipleResponseType
          >
        : References.GetAiAgentOrThrowIfMultipleResponseType)
    | undefined;
};

export function useGetAiAgentOrThrowIfMultipleQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAiAgentOrThrowIfMultipleResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAiAgentOrThrowIfMultipleQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_AI_AGENT_OR_THROW_IF_MULTIPLE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAiAgentOrThrowIfMultiple: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAiAgentOrThrowIfMultipleQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAiAgentOrThrowIfMultipleQueryReturn<T>;
}

type UseGetAiAgentOrThrowIfMultipleLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAiAgentOrThrowIfMultipleResponseType>,
    {},
    T extends true
      ? Record<
          'getAiAgentOrThrowIfMultiple',
          References.GetAiAgentOrThrowIfMultipleResponseType
        >
      : References.GetAiAgentOrThrowIfMultipleResponseType
  >;

export function useGetAiAgentOrThrowIfMultipleLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAiAgentOrThrowIfMultipleResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAiAgentOrThrowIfMultipleLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_AI_AGENT_OR_THROW_IF_MULTIPLE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAiAgentOrThrowIfMultiple: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAiAgentOrThrowIfMultipleLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAiAgentOrThrowIfMultipleLazyQueryReturn<T>;
}

type UseGetAiAgentOrThrowIfMultipleSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetAiAgentOrThrowIfMultipleResponseType>
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getAiAgentOrThrowIfMultiple',
          References.GetAiAgentOrThrowIfMultipleResponseType
        >
      : References.GetAiAgentOrThrowIfMultipleResponseType;
  };

export function useGetAiAgentOrThrowIfMultipleSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAiAgentOrThrowIfMultipleResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAiAgentOrThrowIfMultipleSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_AI_AGENT_OR_THROW_IF_MULTIPLE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAiAgentOrThrowIfMultiple: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAiAgentOrThrowIfMultipleSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAiAgentOrThrowIfMultipleSuspenseQueryReturn<T>;
}

type UseGetAiAgentsForPortalQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAiAgentsForPortalResponseType>,
    References.GetAiAgentsForPortalRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAiAgentsForPortal',
            References.GetAiAgentsForPortalResponseType
          >
        : References.GetAiAgentsForPortalResponseType)
    | undefined;
};

export function useGetAiAgentsForPortalQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAiAgentsForPortalResponseType>,
    References.GetAiAgentsForPortalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAiAgentsForPortalQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_AI_AGENTS_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAiAgentsForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAiAgentsForPortalQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAiAgentsForPortalQueryReturn<T>;
}

type UseGetAiAgentsForPortalLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAiAgentsForPortalResponseType>,
    References.GetAiAgentsForPortalRequestType,
    T extends true
      ? Record<
          'getAiAgentsForPortal',
          References.GetAiAgentsForPortalResponseType
        >
      : References.GetAiAgentsForPortalResponseType
  >;

export function useGetAiAgentsForPortalLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAiAgentsForPortalResponseType>,
    References.GetAiAgentsForPortalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAiAgentsForPortalLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_AI_AGENTS_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAiAgentsForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAiAgentsForPortalLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAiAgentsForPortalLazyQueryReturn<T>;
}

type UseGetAiAgentsForPortalSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetAiAgentsForPortalResponseType>,
    References.GetAiAgentsForPortalRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getAiAgentsForPortal',
        References.GetAiAgentsForPortalResponseType
      >
    : References.GetAiAgentsForPortalResponseType;
};

export function useGetAiAgentsForPortalSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAiAgentsForPortalResponseType>,
    References.GetAiAgentsForPortalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAiAgentsForPortalSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_AI_AGENTS_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAiAgentsForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAiAgentsForPortalSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAiAgentsForPortalSuspenseQueryReturn<T>;
}

type UseGetAiAgentProfilesForPortalQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAiAgentProfilesForPortalResponseType>,
    References.GetAiAgentProfilesForPortalRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAiAgentProfilesForPortal',
            References.GetAiAgentProfilesForPortalResponseType
          >
        : References.GetAiAgentProfilesForPortalResponseType)
    | undefined;
};

export function useGetAiAgentProfilesForPortalQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAiAgentProfilesForPortalResponseType>,
    References.GetAiAgentProfilesForPortalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAiAgentProfilesForPortalQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_AI_AGENT_PROFILES_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAiAgentProfilesForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAiAgentProfilesForPortalQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAiAgentProfilesForPortalQueryReturn<T>;
}

type UseGetAiAgentProfilesForPortalLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAiAgentProfilesForPortalResponseType>,
    References.GetAiAgentProfilesForPortalRequestType,
    T extends true
      ? Record<
          'getAiAgentProfilesForPortal',
          References.GetAiAgentProfilesForPortalResponseType
        >
      : References.GetAiAgentProfilesForPortalResponseType
  >;

export function useGetAiAgentProfilesForPortalLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAiAgentProfilesForPortalResponseType>,
    References.GetAiAgentProfilesForPortalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAiAgentProfilesForPortalLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_AI_AGENT_PROFILES_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAiAgentProfilesForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAiAgentProfilesForPortalLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAiAgentProfilesForPortalLazyQueryReturn<T>;
}

type UseGetAiAgentProfilesForPortalSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetAiAgentProfilesForPortalResponseType>,
      References.GetAiAgentProfilesForPortalRequestType
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getAiAgentProfilesForPortal',
          References.GetAiAgentProfilesForPortalResponseType
        >
      : References.GetAiAgentProfilesForPortalResponseType;
  };

export function useGetAiAgentProfilesForPortalSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAiAgentProfilesForPortalResponseType>,
    References.GetAiAgentProfilesForPortalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAiAgentProfilesForPortalSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_AI_AGENT_PROFILES_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAiAgentProfilesForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAiAgentProfilesForPortalSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAiAgentProfilesForPortalSuspenseQueryReturn<T>;
}

type UseGetHydratedAiAgentDataForPortalQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetHydratedAiAgentDataForPortalResponseType>
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getHydratedAiAgentDataForPortal',
            References.GetHydratedAiAgentDataForPortalResponseType
          >
        : References.GetHydratedAiAgentDataForPortalResponseType)
    | undefined;
};

export function useGetHydratedAiAgentDataForPortalQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.GetHydratedAiAgentDataForPortalResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetHydratedAiAgentDataForPortalQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_HYDRATED_AI_AGENT_DATA_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getHydratedAiAgentDataForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetHydratedAiAgentDataForPortalQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetHydratedAiAgentDataForPortalQueryReturn<T>;
}

type UseGetHydratedAiAgentDataForPortalLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetHydratedAiAgentDataForPortalResponseType>,
    {},
    T extends true
      ? Record<
          'getHydratedAiAgentDataForPortal',
          References.GetHydratedAiAgentDataForPortalResponseType
        >
      : References.GetHydratedAiAgentDataForPortalResponseType
  >;

export function useGetHydratedAiAgentDataForPortalLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetHydratedAiAgentDataForPortalResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetHydratedAiAgentDataForPortalLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_HYDRATED_AI_AGENT_DATA_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getHydratedAiAgentDataForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetHydratedAiAgentDataForPortalLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetHydratedAiAgentDataForPortalLazyQueryReturn<T>;
}

type UseGetHydratedAiAgentDataForPortalSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetHydratedAiAgentDataForPortalResponseType>
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getHydratedAiAgentDataForPortal',
          References.GetHydratedAiAgentDataForPortalResponseType
        >
      : References.GetHydratedAiAgentDataForPortalResponseType;
  };

export function useGetHydratedAiAgentDataForPortalSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetHydratedAiAgentDataForPortalResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetHydratedAiAgentDataForPortalSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_HYDRATED_AI_AGENT_DATA_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getHydratedAiAgentDataForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetHydratedAiAgentDataForPortalSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetHydratedAiAgentDataForPortalSuspenseQueryReturn<T>;
}

type UseGetHydratedAiAgentDataForPortalV2QueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetHydratedAiAgentDataForPortalV2ResponseType>
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getHydratedAiAgentDataForPortalV2',
            References.GetHydratedAiAgentDataForPortalV2ResponseType
          >
        : References.GetHydratedAiAgentDataForPortalV2ResponseType)
    | undefined;
};

export function useGetHydratedAiAgentDataForPortalV2Query<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.GetHydratedAiAgentDataForPortalV2ResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetHydratedAiAgentDataForPortalV2QueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_HYDRATED_AI_AGENT_DATA_FOR_PORTAL_V2_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getHydratedAiAgentDataForPortalV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetHydratedAiAgentDataForPortalV2QueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetHydratedAiAgentDataForPortalV2QueryReturn<T>;
}

type UseGetHydratedAiAgentDataForPortalV2LazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetHydratedAiAgentDataForPortalV2ResponseType>,
    {},
    T extends true
      ? Record<
          'getHydratedAiAgentDataForPortalV2',
          References.GetHydratedAiAgentDataForPortalV2ResponseType
        >
      : References.GetHydratedAiAgentDataForPortalV2ResponseType
  >;

export function useGetHydratedAiAgentDataForPortalV2LazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetHydratedAiAgentDataForPortalV2ResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetHydratedAiAgentDataForPortalV2LazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_HYDRATED_AI_AGENT_DATA_FOR_PORTAL_V2_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getHydratedAiAgentDataForPortalV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetHydratedAiAgentDataForPortalV2LazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetHydratedAiAgentDataForPortalV2LazyQueryReturn<T>;
}

type UseGetHydratedAiAgentDataForPortalV2SuspenseQueryReturn<
  T extends boolean,
> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetHydratedAiAgentDataForPortalV2ResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getHydratedAiAgentDataForPortalV2',
        References.GetHydratedAiAgentDataForPortalV2ResponseType
      >
    : References.GetHydratedAiAgentDataForPortalV2ResponseType;
};

export function useGetHydratedAiAgentDataForPortalV2SuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetHydratedAiAgentDataForPortalV2ResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetHydratedAiAgentDataForPortalV2SuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_HYDRATED_AI_AGENT_DATA_FOR_PORTAL_V2_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getHydratedAiAgentDataForPortalV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetHydratedAiAgentDataForPortalV2SuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetHydratedAiAgentDataForPortalV2SuspenseQueryReturn<T>;
}

type UseDeleteAgentMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.DeleteAgentResponseType>,
  References.DeleteAgentRequestType,
  T extends true
    ? Record<'deleteAgent', References.DeleteAgentResponseType>
    : References.DeleteAgentResponseType
>;

export function useDeleteAgentMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.DeleteAgentResponseType>,
    References.DeleteAgentRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseDeleteAgentMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.DELETE_AGENT_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            deleteAgent: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseDeleteAgentMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseDeleteAgentMutationReturn<T>;
}

type UseRestoreAgentMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.RestoreAgentResponseType>,
  References.RestoreAgentRequestType,
  T extends true
    ? Record<'restoreAgent', References.RestoreAgentResponseType>
    : References.RestoreAgentResponseType
>;

export function useRestoreAgentMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.RestoreAgentResponseType>,
    References.RestoreAgentRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRestoreAgentMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.RESTORE_AGENT_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            restoreAgent: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseRestoreAgentMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseRestoreAgentMutationReturn<T>;
}
